export var OrderBookingMode;
(function(OrderBookingMode) {
    OrderBookingMode[/**
     * Standard paid booking.
     */ "Paid"] = "Paid";
    OrderBookingMode[/**
     * Unpaid booking.
     */ "Unpaid"] = "Unpaid";
    OrderBookingMode[/**
     * Unpaid booking with an extended collection period.
     */ "UnpaidConfirmed"] = "UnpaidConfirmed";
})(OrderBookingMode || (OrderBookingMode = {}));

//# sourceMappingURL=order-booking-mode.js.map